module.exports = "/_next/static/images/smallpanda-e639bf6c1551bd116f4724c59f9b0d3a.png";